<div
  class="wrapper"
  [class.failed]="failed"
  [class.open]="open"
  [class.chat]="chat"
  [class.own]="own"
>
  <div class="header" (click)="toggleCollapse()" [class.non-collapsable]="!collapsable()">
    @if (!header) {
      <div class="default">
        {{ label }}
        <span class="indicator ms-auto">
          <fa-icon [icon]="faChevronDown" size="lg"></fa-icon>
        </span>
      </div>
    }
    @if (header) {
      <ng-container [ngTemplateOutlet]="header"></ng-container>
    }
  </div>
  <ct-lib-collapse [open]="open">
    <ng-content></ng-content>
  </ct-lib-collapse>
</div>
